module.exports = __webpack_public_path__ + "media/images/grade/B-246c650b87c60ba04911f400cffcde13.svg";